namespace Matrix.Data {
    export interface AssignNewSecurityIdResponse extends Serenity.ServiceResponse {
        SecurityId?: number;
    }
}
